import { Award, Building2, HeartHandshake, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const GALLERY_IMAGES = [
  "/references/uni.jpg",
  "/references/schule.jpg",
  "/references/behoerde.jpg",
  "/references/kommune.jpg",
];

const TRUST_ICONS = [Award, Building2, HeartHandshake];

export const References = ({ t }) => (
  <section id="referenzen" data-testid="references-section" className="relative py-24 sm:py-32 px-4 bg-[#E9F3F4]">
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-3xl">
        <Eyebrow>{t.references.label}</Eyebrow>
        <h2 className="mt-4 font-jakarta text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          {t.references.title}
        </h2>
        <p className="mt-5 text-base text-slate-600 leading-relaxed">{t.references.sub}</p>
      </Reveal>

      <Reveal delay={0.1}>
        <p data-testid="gallery-caption" className="mt-14 text-xs font-mono uppercase tracking-[0.2em] text-[#003940]">
          {t.references.galleryCaption}
        </p>
      </Reveal>
      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {GALLERY_IMAGES.map((src, i) => (
          <Reveal key={i} delay={i * 0.08} className={i % 2 === 1 ? "mt-8" : ""}>
            <div
              data-testid={`gallery-image-${i}`}
              className="group relative overflow-hidden rounded-2xl aspect-[3/4] border border-slate-200 shadow-sm"
            >
              <img
                src={src}
                alt={t.references.gallery[i]}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A272C]/70 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" />
              <span
                data-testid={`gallery-label-${i}`}
                className="absolute bottom-3 left-3 text-[10px] font-mono uppercase tracking-[0.15em] text-white border border-white/30 rounded-full px-3 py-1 bg-[#0A272C]/50 backdrop-blur-sm"
              >
                {t.references.gallery[i]}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p data-testid="trust-label" className="mt-16 text-xs font-mono uppercase tracking-[0.2em] text-[#003940]">
          {t.references.trustLabel}
        </p>
      </Reveal>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        {t.references.trust.map((item, i) => {
          const Icon = TRUST_ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.1}>
              <div
                data-testid={`trust-card-${i}`}
                className="h-full p-8 rounded-2xl bg-surface border border-slate-200 flex flex-col shadow-sm"
              >
                <Icon size={22} className="text-[#003940]" />
                <h3 className="mt-4 text-lg font-semibold tracking-tight text-slate-900">{item.title}</h3>
                <p className="mt-3 text-sm text-slate-700 leading-relaxed flex-1">{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <div
          data-testid="references-young"
          className="mt-14 rounded-2xl border border-[#003940]/20 bg-surface p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center gap-6 shadow-sm"
        >
          <div className="flex-1">
            <h3 className="text-xl font-semibold tracking-tight text-slate-900">{t.references.youngTitle}</h3>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed max-w-2xl">{t.references.youngText}</p>
          </div>
          <a
            href="#kontakt"
            data-testid="references-cta"
            className="shrink-0 inline-flex items-center gap-2 rounded-full bg-[#003940] px-6 py-3 text-sm font-semibold text-white hover:bg-[#002A2F] transition-colors"
          >
            {t.references.cta}
            <ArrowRight size={16} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
